// Librerias externas
// import * as XLSX from "xlsx";

import {
  fetchYards,
  deleteYards,
} from "../../../../store/oasis/yardsStore";
import { resetAlert } from "../../helpers";
import type { AlertType } from "../../helpers";

// Tipos auxiliares
export interface Yard {
  [key: string]: any;
}

export interface Alert {
  visible: boolean;
  title: string;
  text: string;
  icon: string;
  confirmButtonText: string;
  confirmButtonColor: string;
  onConfirm: () => void;
  showCancelButton: boolean;
}
type SetAlert = (options: AlertType) => void;
type Translate = (key: string) => string;
export type SetState<T> = (value: T) => void;

// export const fetchResidentialsFromStorage = (
//   setResidentials: SetState<any>,
//   setFirstLoad: SetState<boolean>,
//   setHasLoaded: SetState<boolean>
// ) => {
//   const residentialsString = localStorage.getItem("residentials");
//   const residentialsData = JSON.parse(residentialsString!);

//   if (residentialsData !== null) {
//     setResidentials(residentialsData);
//     setFirstLoad(false);
//   }

//   setHasLoaded(true);
// };

export const yardsTableColumns = (
  t: Translate,
  selectAllCheckboxes: () => any
): any[] => {
  const columns = [
    {
      header: () => selectAllCheckboxes(),
      headerTextAlign: () => "center",
      accessorKey: "checkbox",
      cell: (info: any) => info.getValue()(),
    },
    {
      header: "ID",
      accessorKey: "ID",
      cell: (info: any) => info.getValue()(),
    },
    { header: t("name"), accessorKey: "name", cellTextAlign: () => "left" },
    {
      header: t("location"),
      accessorKey: "location",
      width: "250px",
      cellTextAlign: () => "left",
      cell: (info: any) => {
        const loc = info.getValue();
        return loc?.address ? `${loc.address}` : t("noData");
      },
      id: "location_address",
    },
    {
      header: t("radius"),
      accessorKey: "location",
      cell: (info: any) => {
        const loc = info.getValue();
        return loc?.radius ? `${Math.round(loc.radius)} m` : t("N/A");
      },
      id: "location_radius",
    },
    {
      header: t("phone"),
      accessorKey: "phone",
      cell: (info: any) => {
        const phone = info.getValue();
        return phone?.number
          ? `${phone.areaCodeNumber || ""} ${phone.number}`
          : t("noData");
      },
    },
    {
      header: t("created"),
      accessorKey: "createdAt",
      cell: (info: any) => {
        const val = info.getValue();
        if (val?._seconds) {
          const date = new Date(val._seconds * 1000);
          return date.toLocaleString();
        }
        return t("noData");
      },
    },
    {
      header: t("updated"),
      accessorKey: "updatedAt",
      cell: (info: any) => {
        const val = info.getValue();
        if (val?._seconds) {
          const date = new Date(val._seconds * 1000);
          return date.toLocaleString();
        }
        return t("noData");
      },
    },
    {
      header: t("edit"),
      headerTextAlign: () => "center",
      accessorKey: "edit",
      cell: (info: any) => info.getValue()(),
    },
  ];
  return columns;
};

export const onDelete = async (
  yardsData: any,
  setAlert: SetAlert,
  t: Translate,
  setIsAnyChecked: SetState<boolean>,
  setSelectAll: SetState<boolean>,
  setYardsDelete: SetState<any[]>,
  setLoading: SetState<boolean>,
  setYards: SetState<any[]>
): Promise<void> => {
  try {
    setLoading(true);
    await deleteYards(yardsData);
    return setAlert({
      visible: true,
      title: t("successful"),
      text:
        yardsData.yardIDs.length > 1
          ? t("yardsEliminated")
          : t("yardEliminated"),
      icon: "success",
      confirmButtonText: t("closeButton"),
      confirmButtonColor: "#1C93FF",
      onConfirm: async () => {
        await fetchYards().then((yards) => setYards(yards));
        setYardsDelete([]);
        setIsAnyChecked(false);
        setSelectAll(false);
        setAlert(resetAlert());
      },
      showCancelButton: false,
    });
  } catch (error: any) {
    console.log(error);

    if (error.message === "Server Error") {
      return setAlert({
        visible: true,
        title: "500",
        text: t("internalServerError"),
        icon: "error",
        confirmButtonText: t("closeButton"),
        confirmButtonColor: "#1C93FF",
        onConfirm: () => setAlert(resetAlert()),
        showCancelButton: false,
      });
    }
    return setAlert({
      visible: true,
      title: t("unexpectedError"),
      text: t("somethingWentWrong"),
      icon: "error",
      confirmButtonText: t("closeButton"),
      confirmButtonColor: "#1C93FF",
      onConfirm: () => setAlert(resetAlert()),
      showCancelButton: false,
    });
  } finally {
    setLoading(false);
  }
};

// export const sendFile = async (
//   residentialsData: any[],
//   dispatch: Dispatch,
//   setAlert: SetState<Alert>,
//   t: TFunction,
//   setSendingFile: SetState<boolean>,
//   setShowModal: SetState<boolean>,
//   setResponseFileUpload: SetState<any>
// ): Promise<void> => {
//   setSendingFile(true);
//   try {
//     const resultAction = await dispatch(
//       createResidentialsForBatch(residentialsData)
//     );
//     unwrapResult(resultAction);
//     const response = resultAction.payload;
//     setResponseFileUpload(response);
//     setShowModal(true);
//   } catch (error: any) {
//     if (error.message === "Server Error") {
//       return setAlert({
//         visible: true,
//         title: "500",
//         text: t("internalServerError"),
//         icon: "error",
//         confirmButtonText: t("closeButton"),
//         confirmButtonColor: "#1C93FF",
//         onConfirm: () => setAlert(resetAlert()),
//         showCancelButton: false,
//       });
//     }
//     return setAlert({
//       visible: true,
//       title: t("unexpectedError"),
//       text: t("somethingWentWrong"),
//       icon: "error",
//       confirmButtonText: t("closeButton"),
//       confirmButtonColor: "#1C93FF",
//       onConfirm: () => setAlert(resetAlert()),
//       showCancelButton: false,
//     });
//   } finally {
//     setSendingFile(false);
//   }
// };

// export const closeResponseModal = (
//   response: any,
//   userID: string,
//   role: string,
//   setFileUploaded: SetState<boolean>,
//   setDataFile: SetState<any[]>,
//   dispatch: Dispatch,
//   setAlert: SetState<Alert>
// ) => {
//   if (response.success.length > 0) {
//     dispatch(fetchResidentials({ userID, role }));
//     setFileUploaded(false);
//     setDataFile([]);
//     dispatch(setReloadResidentials(true));
//     setAlert(resetAlert());
//   } else {
//     setFileUploaded(false);
//     setDataFile([]);
//     setAlert(resetAlert());
//   }
// };

// export const onDownload = (residentials: any[], t: TFunction): any[] => {
//   return residentials.map((data) => {
//     return {
//       [t("residentialName")]: data?.name ? data.name : t("noData"),
//       [t("location")]: data?.location?.address
//         ? data.location.address
//         : t("noData"),
//       [t("radius")]: data?.location?.radius
//         ? `${Math.round(data.location.radius)} m`
//         : t("noData"),
//       [t("admins")]:
//         data?.admins.length > 0
//           ? data.admins
//               .map((item: any) => `${item.firstName} ${item.lastName}`)
//               .join(", ")
//           : t("noData"),
//       [t("guardHouseContactNumber")]:
//         data?.guardHouseContactNumber && data?.areaCodeNumber
//           ? `${data.areaCodeNumber} ${data.guardHouseContactNumber}`
//           : t("noData"),
//       [t("timeZone")]: data?.timeZone ? data.timeZone : t("noData"),
//       [t("privacyPolicies")]: data?.privacyPolicies
//         ? data.privacyPolicies
//         : t("noData"),
//       [t("accountHolder")]: data?.bankDetails?.accountHolder
//         ? data.bankDetails.accountHolder
//         : t("noData"),
//       [t("accountNumber")]: data?.bankDetails?.accountNumber
//         ? data.bankDetails.accountNumber
//         : t("noData"),
//       [t("bankName")]: data?.bankDetails?.bankName
//         ? data.bankDetails.bankName
//         : t("noData"),
//       [t("clabe")]: data?.bankDetails?.clabe
//         ? data.bankDetails.clabe
//         : t("noData"),
//       [t("createdAt")]: formatDate(
//         data.createdAt._seconds,
//         data.createdAt._nanoseconds
//       ),
//       [t("updatedAt")]: formatDate(
//         data.updatedAt._seconds,
//         data.updatedAt._nanoseconds
//       ),
//     };
//   });
// };

// export const responseTableColumns = (t: TFunction): any[] => {
//   return [
//     {
//       header: t("number"),
//       cell: (info: any) => {
//         return info.row.index + 1;
//       },
//       cellColorText: (cell: any) => {
//         return cell.row.original.responseStatus === "success" ? "black" : "red";
//       },
//       fontWeight: "bold",
//     },
//     {
//       header: t("name"),
//       accessorKey: "name",
//       cellColorText: (cell: any) => {
//         if (
//           (!cell.getValue() &&
//             cell.row.original.responseStatus !== "success") ||
//           (cell.getValue() &&
//             cell.row.original.responseStatus !== "success" &&
//             cell.row.original.pathError.includes("name"))
//         ) {
//           return "red";
//         }
//       },
//       cell: (info: any) => {
//         return info.getValue() ? info.getValue() : t("obligatory");
//       },
//     },
//     {
//       header: t("accountHolder"),
//       accessorKey: "bankDetails.accountHolder",
//       cell: (info: any) => {
//         return info.getValue() ? info.getValue() : t("noData");
//       },
//     },
//     {
//       header: t("accountNumber"),
//       accessorKey: "bankDetails.accountNumber",
//       cell: (info: any) => {
//         return info.getValue() ? info.getValue() : t("noData");
//       },
//     },
//     {
//       header: t("bankName"),
//       accessorKey: "bankDetails.bankName",
//       cell: (info: any) => {
//         return info.getValue() ? info.getValue() : t("noData");
//       },
//     },
//     {
//       header: t("clabe"),
//       accessorKey: "bankDetails.clabe",
//       cell: (info: any) => {
//         return info.getValue() ? info.getValue() : t("noData");
//       },
//     },
//     {
//       header: t("observation"),
//       accessorKey: "observation",
//       cellColorText: (cell: any) => {
//         return cell.row.original.responseStatus === "success" ? "green" : "red";
//       },
//       cell: (info: any) => info.getValue()(),
//     },
//   ];
// };

// export const onFileUpload = (
//   file: File,
//   setFileUploaded: SetState<boolean>,
//   setDataFile: SetState<any[]>,
//   setAlert: SetState<Alert>,
//   t: TFunction
// ) => {
//   setFileUploaded(true);

//   const processData = (data: any[]) => {
//     const columnMapping: Record<string, string> = {
//       [t("residentialName")]: "name",
//       [t("accountHolder")]: "accountHolder",
//       [t("accountNumber")]: "accountNumber",
//       [t("nameBank")]: "bankName",
//       [t("clabeAccount")]: "clabe",
//     };

//     const expectedKeys = [
//       "name",
//       "accountHolder",
//       "accountNumber",
//       "bankName",
//       "clabe",
//     ];

//     const transformedData = data.map((row) => {
//       const transformedRow: Record<string, any> = {};
//       Object.keys(row).forEach((originalKey) => {
//         const newKey = columnMapping[originalKey] || originalKey;
//         transformedRow[newKey] = row[originalKey];
//       });
//       return transformedRow;
//     });

//     const transformedKeys =
//       transformedData.length > 0 ? Object.keys(transformedData[0]) : [];

//     const isValid = expectedKeys.every((key) => transformedKeys.includes(key));

//     if (isValid) {
//       const filteredData = transformedData.filter((row) =>
//         Object.values(row).some((value) => value)
//       );
//       if (filteredData.length === 0) {
//         return setAlert({
//           visible: true,
//           title: t("emptyFile"),
//           text: t("emptyFileText"),
//           icon: "warning",
//           confirmButtonText: t("closeButton"),
//           confirmButtonColor: "#1C93FF",
//           onConfirm: () => {
//             setFileUploaded(false);
//             setDataFile([]);
//             setAlert(resetAlert());
//           },
//           showCancelButton: false,
//         });
//       }
//       return setDataFile(filteredData);
//     } else {
//       return setAlert({
//         visible: true,
//         title: t("invalidFile"),
//         text: t("invalidFileText"),
//         icon: "error",
//         confirmButtonText: t("closeButton"),
//         confirmButtonColor: "#1C93FF",
//         onConfirm: () => {
//           setFileUploaded(false);
//           setDataFile([]);
//           setAlert(resetAlert());
//         },
//         showCancelButton: false,
//       });
//     }
//   };

//   const fileExtension = file.name.split(".").pop()?.toLowerCase();

//   if (fileExtension === "xlsx") {
//     const reader = new FileReader();
//     reader.onload = (e: ProgressEvent<FileReader>) => {
//       const rawData = new Uint8Array(e.target!.result as ArrayBuffer);
//       const workbook = XLSX.read(rawData, { type: "array" });
//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//       const headers = jsonData[0] as string[];
//       const rows = jsonData.slice(1);
//       const processedData = rows.map((row: any[]) => {
//         const obj: Record<string, any> = {};
//         headers.forEach((header, index) => {
//           obj[header] = row[index];
//         });
//         return obj;
//       });

//       processData(processedData);
//     };
//     reader.readAsArrayBuffer(file);
//   } else {
//     setAlert({
//       visible: true,
//       title: t("invalidFileType"),
//       text: t("invalidFileTypeText"),
//       icon: "error",
//       confirmButtonText: t("closeButton"),
//       confirmButtonColor: "#1C93FF",
//       onConfirm: () => {
//         setFileUploaded(false);
//         setDataFile([]);
//         setAlert(resetAlert());
//       },
//       showCancelButton: false,
//     });
//   }
// };

// export const residentialsSteps = (t: TFunction): any[] => [
//   {
//     step: 0,
//     target: "body",
//     content: t("residentials.step0"),
//     placement: "center",
//     disableBeacon: true,
//   },
//   {
//     step: 1,
//     target: "#create-new-residential-btn",
//     content: t("residentials.step1"),
//     placement: "bottom",
//   },
//   {
//     step: 2,
//     target: "body",
//     content: t("residentials.step2"),
//     placement: "center",
//   },
//   {
//     step: 3,
//     target: "#residential-form-container",
//     content: t("residentials.step3"),
//   },
//   {
//     step: 4,
//     target: "#security-config-section",
//     content: t("residentials.step4"),
//     placement: "top",
//   },
//   {
//     step: 5,
//     target: "#bankData",
//     content: t("residentials.step5"),
//   },
//   {
//     step: 6,
//     target: "#saveData",
//     content: t("residentials.step6"),
//     placement: "top",
//   },
//   {
//     step: 7,
//     target: "body",
//     content: t("residentials.step7"),
//     placement: "center",
//   },
//   {
//     step: 8,
//     target: "#loadButton",
//     content: t("residentials.step8"),
//     placement: "top",
//   },
//   {
//     step: 9,
//     target: "#residentialExcel",
//     content: t("residentials.step9"),
//     placement: "top",
//   },
//   {
//     step: 10,
//     target: "#residentials-table-container",
//     content: t("residentials.step10"),
//     placement: "top",
//   },
//   {
//     step: 11,
//     target: "body",
//     content: t("residentials.step11"),
//     placement: "center",
//     disableBeacon: true,
//   },
// ];

// export const residentialsTutorialCallback = ({
//   dispatch,
//   navigate,
//   t,
// }: {
//   dispatch: Dispatch;
//   navigate: (path: string) => void;
//   t: TFunction;
// }) => {
//   return async (data: any) => {
//     const { action, index } = data;
//     const steps = residentialsSteps(t);
//     const currentStep = steps[index];

//     if (["start", "next", "update"].includes(action)) {
//       const selector = currentStep?.target;
//       if (selector && typeof selector === "string") {
//         try {
//           await waitForElement(selector);
//         } catch (error) {
//           console.error("Tutorial target not found:", error);
//         }
//       }

//       switch (index) {
//         case 2:
//           navigate("/residentials/form");
//           break;
//         case 7:
//           navigate("/residentials");
//           break;
//       }
//     }

//     if (["skip", "close", "reset"].includes(action)) {
//       dispatch(setTutorial({ runTutorial: false, current: "" }));
//       navigate("/residentials");
//     }
//   };
// };
